import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import ReactPWAInstallProvider from "./PWAInstall";

import App from "./App";
import ErrorPage from "./ErrorPage";
import Home from "./Home";
import Scan from "./Scan";
import Input from "./Input";
import TVMatch from "./TVMatch";
import NoMatch from "./NoMatch";

import "./styles/index.css";

// The model JSON data is required in the Scan and Input components.
async function modelDataLoader() {
    // Check the session storage.
    // Get saved data from sessionStorage if it's there, otherwise load from the server
    let modelData;
    let modelDataString = sessionStorage.getItem("modelData");

    if (modelDataString) {
        try {
            modelData = JSON.parse(modelDataString);
        } catch (error) {
            console.error("modelData JSON failed to parse");
            throw error;
        }
    }

    if (!modelData || typeof modelData !== "object") {
        try {
            const modelDataRequest = await fetch("tvModels.json");

            // Parse as text then try to parse as JSON, if it works then restringify and put into the
            // session cache and return the JSON. Otherwise throw an error.
            const text = await modelDataRequest.text();
            modelData = JSON.parse(text);
            sessionStorage.setItem("modelData", JSON.stringify(modelData));
        } catch (error) {
            console.log("Failed to load JSON from the server");
            throw error;
        }
    }

    return modelData;
}

// Load the tutorial link data for the success page.
async function tutorialDataLoader() {
    // Cache in the session storage so we don't need to make the fetch request on every route to the
    // page.
    let tutorialData;
    let tutorialDataString = sessionStorage.getItem("tutorialData");

    if (tutorialDataString) {
        try {
            tutorialData = JSON.parse(tutorialDataString);
        } catch (error) {
            console.error("tutorialData JSON failed to parse");
            throw error;
        }
    }

    if (!tutorialData || typeof tutorialData !== "object") {
        try {
            const tutorialDataRequest = await fetch("dict.json");

            // Parse as text then try to parse as JSON, if it works then restringify and put into the
            // session cache and return the JSON. Otherwise throw an error.
            const text = await tutorialDataRequest.text();
            tutorialData = JSON.parse(text);
            sessionStorage.setItem(
                "tutorialData",
                JSON.stringify(tutorialData)
            );
        } catch (error) {
            console.log("Failed to load JSON from the server");
            throw error;
        }
    }

    return tutorialData;
}

const router = createBrowserRouter(
    [
        {
            path: "/",
            element: <App />,
            errorElement: <ErrorPage />,
            children: [
                { index: true, element: <Home /> },
                {
                    path: "/scan",
                    loader: modelDataLoader,
                    element: <Scan />,
                },
                {
                    path: "/input",
                    loader: modelDataLoader,
                    element: <Input />,
                },
                {
                    path: "/tv-match",
                    loader: tutorialDataLoader,
                    element: <TVMatch />,
                },
                {
                    path: "/no-match",
                    element: <NoMatch />,
                },
            ],
        },
    ],
    { basename: process.env.REACT_APP_ROUTER_BASE_PATH }
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <ReactPWAInstallProvider>
            <RouterProvider router={router} />
        </ReactPWAInstallProvider>
    </React.StrictMode>
);
